import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import Button from 'components/Button/index'

export const SectionWrapper = styled(Flex)`
  width: 100%;
  height: calc(100vh - 142px);
  border: 1px solid ${COLORS.PAGE_BORDER};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  border-radius: 10px;
  overflow: scroll;
  background: ${COLORS.WHITE};
  overflow: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: '';
  }
`

export const TopHeader = styled(Flex)`
  padding: 20px 25px;
  position: relative;
  width: 100%;
  font-size: 2em;
`
export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: ${COLORS.GREY_P_100};
`

export const TopRightFlex = styled(Flex)`
  gap: 15px;
  align-items: center;
`
export const SmallButtons = styled(Button.Default)`
  background: ${COLORS.WHITE};
  padding: 9px;
  border: ${props => !props.border && 'none'};
  > div {
    margin-left: 0;
  }
`
export const ToggleContainer = styled(Flex)`
  width: fit-content;
  justify-content: center;
  align-items: center;
  padding: 3px 4px;
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 10px;
  cursor: pointer;
`

export const CommonToggle = styled.div`
  padding: 0.3rem 0.7rem;
  color: ${props => props.color};
  background: ${props => props.background} !important;
  border-radius: 8px;
  transition: 0.5s;
  z-index: 1;
`
export const DriveCount = styled.div`
  background-color: ${COLORS.RED_T_20};
  font-weight: 700;
  font-size: 0.75rem;
  line-height: 1rem;
  padding: 0.1rem 0.3rem;
  color: ${COLORS.WHITE};
  border-radius: 0.4rem;
  margin-left: 0.2rem;
`
export const ToggleText = styled.div`
  font-size: 0.8rem;
  color: ${props => props.color};
  font-weight: 600;
  padding: 0.5rem 0;
`
